export default __webpack_public_path__ + "static/media/user_avatar.43501b3f.png";